import api from "./api";

export const getGlobalMonitoringData = async () => {
    const [
        shipmentsRes,
        ordersRes,
        iotRes,
        blockchainRes,
        notificationsRes,
        logsRes,
    ] = await Promise.allSettled([
        api.get("/Shipment/all"),
        api.get("/orders/active"),
        api.get("/IoTDevice"),
        api.get("/BlockchainLog"),
        api.get("/notifications"),
        api.get("/SystemLog"),
    ]);

    const shipments =
        shipmentsRes.status === "fulfilled" && Array.isArray(shipmentsRes.value.data)
            ? shipmentsRes.value.data
            : [];

    const orders =
        ordersRes.status === "fulfilled" && Array.isArray(ordersRes.value.data)
            ? ordersRes.value.data
            : [];

    const devices =
        iotRes.status === "fulfilled" && Array.isArray(iotRes.value.data)
            ? iotRes.value.data
            : [];

    const blockchainLogs =
        blockchainRes.status === "fulfilled" && Array.isArray(blockchainRes.value.data)
            ? blockchainRes.value.data
            : [];

    const notifications =
        notificationsRes.status === "fulfilled" && Array.isArray(notificationsRes.value.data)
            ? notificationsRes.value.data
            : [];

    const systemLogs =
        logsRes.status === "fulfilled" && Array.isArray(logsRes.value.data)
            ? logsRes.value.data
            : [];

    const onlineDevices = devices.filter((d) => {
        if (!d.lastUpdated) return false;
        return Date.now() - new Date(d.lastUpdated).getTime() < 2 * 60 * 1000;
    }).length;

    return {
        shipments,
        orders,
        devices,
        blockchainLogs,
        notifications,
        systemLogs,
        activeShipments: shipments.length,
        activeOrders: orders.length,
        iotDevices: devices.length,
        onlineDevices,
        blockchainEvents: blockchainLogs.length,
        notificationsCount: notifications.length,
        criticalEvents: systemLogs.filter((x) =>
            JSON.stringify(x).toLowerCase().includes("critical")
        ).length,
        aiRisk: 6,
        trustScore: 94,
    };
};

export default {
    getGlobalMonitoringData,
};